import {UserTagModel} from "./user-tag.model";
import {Type} from "class-transformer";

export class FolderModel {
  folderId: number;
  name: string;
  tagType: string;
  @Type(() => UserTagModel)
  tags: UserTagModel[];
}
